module.exports = __webpack_public_path__ + "static/media/4-en.1e26b74.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/4-en.wav
// module id = AmSE
// module chunks = 1